import * as React from "react";
import { Trans as I18NextTrans } from "react-i18next";
import Text from "./Text";
import { Constants } from "../utils";

// CRA + TS in this repo sometimes fails to pick up the generic JSX signatures
// from react-i18next's `Trans` type, so we expose a stable wrapper component.
const TransBase = I18NextTrans as unknown as React.ComponentType<any>;

export default function Trans(props: any) {
  const needsTermsAndPrivacyLinks =
    (props?.i18nKey === "login.terms.intro" ||
      props?.i18nKey === "booking.iAgreeTo") &&
    !props?.components;

  if (needsTermsAndPrivacyLinks) {
    return (
      <TransBase
        {...props}
        components={{
          termsLink: (
            <Text
              as="a"
              level="a"
              target="_blank"
              href={Constants.urls.termsOfUse}
            />
          ),
          privacyLink: (
            <Text
              as="a"
              level="a"
              target="_blank"
              href={Constants.urls.privacy}
            />
          ),
        }}
      />
    );
  }

  return <TransBase {...props} />;
}
